module.exports = __webpack_public_path__ + "img/logo.1c4d3fce.png";